// ============================================================================
// ÄNDERUNGSPROTOKOLL - CustomersSection.js
// ============================================================================
//
// DATUM: 25.11.2025
//
// ZWECK DER ÄNDERUNG:
// Die gesamte CustomersSection wurde temporär ausgeblendet. Diese Section
// enthielt:
// - Überschrift "Unsere Kunden"
// - Logo-Karussell mit 15 Kundenlogos (First Bus, Transdev, Stagecoach,
//   Stadtwerke Schweinfurt, Landbus Unterland, Dr. Richard, Verkehrsbetriebe
//   Plön, HADAG, Verkehrsverbund Tirol, NPH, Arriva DB, Abellio, KVG Lippe,
//   Bus Verkehr Berlin, Stadtverkehr Dettmold)
// - Kunden-Zitate/Reviews mit Navigation (z.B. Maurice Litz Review)
// - Fahrlinienbogen-Bild (bow.svg) an der Seite
//
// AUSGANGSPUNKT (VORHER):
// - Imports: React, useState, Swiper, SwiperSlide, Autoplay, bowImage,
//   FadeInImage, useTranslation
// - Komponente mit useState für activeQuote und slideDirection
// - customerLogos Array mit 15 Logo-Objekten
// - Return: Vollständige Section mit Logo-Carousel und Quote-Slider
//
// ENDPUNKT (NACHHER):
// - Komponente gibt jetzt `return null` zurück → nichts wird gerendert
// - Alle Imports auskommentiert
// - Gesamte Original-Implementierung in Block-Kommentar erhalten
//
// ZUM REAKTIVIEREN:
// 1. Imports wieder einkommentieren (Zeilen unter diesem Block)
// 2. `return null;` entfernen
// 3. Block-Kommentar um die Original-Implementierung entfernen
//
// VERKNÜPFUNG:
// Diese Section wird in App.js eingebunden (<CustomersSection />).
// Die Einbindung dort muss NICHT geändert werden, da die Komponente
// einfach null zurückgibt.
// ============================================================================

// TEMPORARILY COMMENTED OUT - Customers section hidden from frontend
// import React, { useState } from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay } from 'swiper/modules';
// import 'swiper/css';
// import bowImage from '../img/bow.svg';
// import FadeInImage from './FadeInImage';
// import { useTranslation } from '../i18n/useTranslation';

const CustomersSection = () => {
  // Temporarily returning null to hide customers section from frontend
  return null;

  /* ORIGINAL IMPLEMENTATION - COMMENTED OUT
  const { t } = useTranslation();
  const [activeQuote, setActiveQuote] = useState(0);
  const [slideDirection, setSlideDirection] = useState('right');

  const quotes = t('customers.quotes');

  const handleQuoteChange = (newIndex) => {
    if (newIndex > activeQuote) {
      setSlideDirection('right');
    } else {
      setSlideDirection('left');
    }
    setActiveQuote(newIndex);
  };

  const customerLogos = [
    { src: "https://BusAgent.com/wp-content/uploads/2023/01/02_transdev-logo.png", alt: "Transdev Logo" },
    { src: "https://BusAgent.com/wp-content/uploads/2024/07/Statdwerke-Schweinfurt-300x109.jpeg", alt: "Stadtwerke Schweinfurt" },
    { src: "https://BusAgent.com/wp-content/uploads/2023/01/stagecoach-uk-bus-vector-logo-1.svg", alt: "Stagecoach Logo" },
    { src: "https://BusAgent.com/wp-content/uploads/2024/07/Landbus-Unterland-300x75.png", alt: "Landbus Unterland" },
    { src: "https://BusAgent.com/wp-content/uploads/2023/01/Logo_Dr._Richard.svg", alt: "Logo Dr. Richard" },
    { src: "https://BusAgent.com/wp-content/uploads/2024/07/Verkehrsbetriebe-Plon-300x77.png", alt: "Verkehrsbetriebe Plön" },
    { src: "https://BusAgent.com/wp-content/uploads/2024/07/HADAG-300x200.jpg", alt: "HADAG" },
    { src: "https://BusAgent.com/wp-content/uploads/2024/07/Verkehrsverbund-Tirol-300x300.jpeg", alt: "Verkehrsverbund Tirol" },
    { src: "https://BusAgent.com/wp-content/uploads/2024/07/NPH-Nahverkehrsverbund-Paderborn-Hoxter-300x225.jpeg", alt: "NPH Nahverkehrsverbund Paderborn-Höxter" },
    { src: "https://BusAgent.com/wp-content/uploads/2023/01/Arriva_DB_company_2017_logo.svg", alt: "Arriva DB Logo" },
    { src: "https://BusAgent.com/wp-content/uploads/2023/01/Abellio_logo.svg", alt: "Abellio Logo" },
    { src: "https://BusAgent.com/wp-content/uploads/2024/07/KVG-Lippe-300x169.jpeg", alt: "KVG Lippe" },
    { src: "https://BusAgent.com/wp-content/uploads/2025/02/First-Bus-New-Logo-Large-300x66.png", alt: "First Bus Logo" },
    { src: "https://BusAgent.com/wp-content/uploads/2023/01/Bus_Verkehr_Berlin_BVB.net_Logo.svg", alt: "Bus Verkehr Berlin Logo" },
    { src: "https://BusAgent.com/wp-content/uploads/2024/07/Stadtverkehr-Dettmold.jpeg", alt: "Stadtverkehr Dettmold" }
  ];

  return (
    <section className="bg-white py-20 lg:py-32 overflow-hidden relative">
      {/* Fahrlinienbogen links - nur auf größeren Bildschirmen anzeigen *}
      <div className="hidden xl:block absolute left-0 top-64 z-0 w-80 h-80 lg:w-[500px] lg:h-[500px]">
        <img
          src={bowImage}
          alt="Fahrlinienbogen"
          className="w-full h-full object-contain"
          style={{
            opacity: 1,
            filter: 'drop-shadow(0 0 40px rgba(59, 130, 246, 0.6)) drop-shadow(0 0 80px rgba(59, 130, 246, 0.4))'
          }}
        />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <h2 className="text-4xl lg:text-5xl font-extrabold text-brand-dark-blue text-center mb-12">
          {t('customers.title')}
        </h2>

        {/* Logo Carousel *}
        <div className="mb-20 mx-auto max-w-5xl">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={50}
            slidesPerView={5}
            loop={true}
            speed={1000}
            autoplay={{
              delay: 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false
            }}
            breakpoints={{
              320: {
                slidesPerView: 2,
                spaceBetween: 30
              },
              640: {
                slidesPerView: 3,
                spaceBetween: 40
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 40
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 50
              }
            }}
            className="customer-logos-carousel"
          >
            {customerLogos.map((logo, index) => (
              <SwiperSlide key={index}>
                <div className="flex items-center justify-center h-20">
                  <FadeInImage
                    src={logo.src}
                    alt={logo.alt}
                    className="max-h-full max-w-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                    loading="lazy"
                    width="120"
                    height="50"
                    showSkeleton={false}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="mt-20 lg:mt-32 max-w-5xl mx-auto flex justify-end">
          <div className="relative max-w-xl h-[380px] group">
            <div className="absolute -top-8 left-0 sm:-left-8 text-blue-200" style={{ fontSize: '6rem', lineHeight: 1, opacity: 0.3, zIndex: 50 }}>
              <span className="sm:text-[8rem]">"</span>
            </div>

            {/* Left Arrow - Desktop only *}
            <button
              onClick={() => handleQuoteChange(activeQuote === 0 ? quotes.length - 1 : activeQuote - 1)}
              className="hidden lg:flex absolute left-[-60px] top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white shadow-lg hover:shadow-xl hover:bg-brand-dark-blue hover:text-white transition-all duration-300 items-center justify-center opacity-0 group-hover:opacity-100 z-50"
              aria-label={t('customers.prevQuote')}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
            </button>

            {/* Right Arrow - Desktop only *}
            <button
              onClick={() => handleQuoteChange(activeQuote === quotes.length - 1 ? 0 : activeQuote + 1)}
              className="hidden lg:flex absolute right-[-60px] top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white shadow-lg hover:shadow-xl hover:bg-brand-dark-blue hover:text-white transition-all duration-300 items-center justify-center opacity-0 group-hover:opacity-100 z-50"
              aria-label={t('customers.nextQuote')}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </button>

            <div className="relative h-[320px] overflow-hidden rounded-lg touch-pan-y">
               <blockquote
   key={activeQuote}
   className={`p-6 transition-all duration-500 ease-out h-[280px] overflow-y-auto pr-2`}
   style={{
     animation: slideDirection === 'right'
       ? 'slideInFromRight 0.5s ease-out'
       : 'slideInFromLeft 0.5s ease-out'
   }}
   onTouchStart={(e) => {
     const touchStartX = e.touches[0].clientX;
     e.currentTarget.setAttribute('data-touch-start', touchStartX);
   }}
   onTouchEnd={(e) => {
     const touchStartX = parseFloat(e.currentTarget.getAttribute('data-touch-start') || '0');
     const touchEndX = e.changedTouches[0].clientX;
     const diff = touchStartX - touchEndX;

     if (Math.abs(diff) > 50) {
       if (diff > 0) {
         handleQuoteChange(activeQuote === quotes.length - 1 ? 0 : activeQuote + 1);
       } else {
         handleQuoteChange(activeQuote === 0 ? quotes.length - 1 : activeQuote - 1);
       }
     }
   }}
 >
                <p className="text-base md:text-lg font-normal text-brand-dark-blue leading-relaxed">
                  "{quotes[activeQuote].text}"
                </p>
                <footer className="mt-6">
                  <p className="font-bold text-brand-dark-blue text-lg">{quotes[activeQuote].author}</p>
                  <p className="text-gray-600 text-sm">{quotes[activeQuote].position}</p>
                </footer>
              </blockquote>
            </div>

            {/* Navigation Dots - Fixed Position *}
            <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex justify-center gap-2">
              {quotes.map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleQuoteChange(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === activeQuote
                      ? 'bg-brand-dark-blue scale-125'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                  aria-label={`${t('customers.quoteNumber')} ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
  */
};

export default CustomersSection;